import React from 'react';
import { useParams } from 'react-router-dom';
import { getDataFromLocalStorage } from 'utils/helpers';
import EventManagement from 'pages/Common/RequestRaisedAndReceived/EventManagement/EventManagement';
import CreateUser from 'pages/Common/RequestRaisedAndReceived/RBACManagement/CreateUser';
import SwitchUser from 'pages/Common/RequestRaisedAndReceived/RBACManagement/SwitchUser';
import CertificateManagement from 'pages/Common/RequestRaisedAndReceived/CertificateManagement';
import CertificateRequest from 'pages/Common/RequestRaisedAndReceived/CertificateManagement/CertificateRequest/CertificateRequest';
import MembershipTypeChange from 'pages/Common/RequestRaisedAndReceived/MembershipTypeChange/MembershipTypeChange';

const RequestReceived = () => {
  const params = useParams();
  const { type } = params;
  const userType = getDataFromLocalStorage('user_type');
  return (
    <div>
      {type === 'event-management' && <EventManagement />}
      {type === 'create-user' && <CreateUser />}
      {type === 'switch-user' && <SwitchUser />}
      {type === 'certificates-event' && <CertificateRequest />}
      {type === 'participants-event' && <CertificateManagement />}
      {type === 'membership-type-change' && <MembershipTypeChange />}

      {/* {'participants-event'.includes(type) && <CertificateManagement />} */}
    </div>
  );
};

export default RequestReceived;
